import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { config } from "../../constants/app.constants";

// Timeout (ms) for any RTK Query request. If a request hasn't responded by
// this point we treat it as failed so the UI can recover instead of showing
// the loader forever.
const REQUEST_TIMEOUT_MS = 60000;

export const api = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: config.API_URL,
    timeout: REQUEST_TIMEOUT_MS,
    prepareHeaders: (headers) => {
      // Get user object from localStorage
      const userStr = localStorage.getItem("user");

      if (userStr) {
        try {
          // Parse the user object
          const user = JSON.parse(userStr);

          // Check if user has access token
          if (user && user.access) {
            // Set Authorization header with proper Bearer format
            headers.set("Authorization", `Bearer ${user.access}`);
          }
        } catch (error) {
          console.error("Error parsing user from localStorage:", error);
        }
      }

      return headers;
    },
  }),
  tagTypes: [
    "RoyaltySales",
    "FilingPlans",
    "PartnerDashboard",
    "AdminProducts",
    "MOM",
    "InteractiveMaps",
    "PartnerComplianceLetter",
    "PartnerInvoice",
    "AdminPartner",
    "Countries",
    "CutOffDate",
    "LetterSubmissionDate",
    "ProductDevelopmentTimeline",
    "SalesReport",
    "SalesReportAPI",
    "SalesReportFDF",
    "AdminDashboard",
    "ProjectCount",
    "ProductCompanyCount",
    "ProductCountryCount",
    "CompanyCount",
    "CountryProduct",
    "Sales",
    "AdminComplianceList",
    "AssignedCompliance",
    "TaxRequest",
    "LicensorsPartners",
    "AdminLicensor",
    "ApprovalRequests",
  ],
  endpoints: () => ({}),
});
